import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { CoreConfigService } from "@core/services/config.service";
import { AuthenticationService } from "../../../api/services/authentication.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LogoService } from "../../../util/service/logo.service";

@Component({
    selector: "app-auth-forgot-password-v1",
    templateUrl: "./auth-forgot-password-v1.component.html",
    styleUrls: ["./auth-forgot-password-v1.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AuthForgotPasswordV1Component implements OnInit {
  // Public
  public coreConfig: any;
  public forgotPasswordForm: UntypedFormGroup;
  public submitted = false;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {FormBuilder} _formBuilder
   *
   * @param _authenticationService
   * @param toastrService
   * @param router
   * @param translate
   * @param logoService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private _authenticationService: AuthenticationService,
    private toastrService: ToastrService,
    private router: Router,
    private translate: TranslateService,
    public logoService: LogoService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.forgotPasswordForm.controls;
  }

  /**
   * On Submit
   */
  onSubmit() {
    this.submitted = true;

    this.forgotPasswordForm.get("email")?.setValue(this.forgotPasswordForm.get("email")?.value.trim());

    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this._authenticationService
      .authControllerSendForgotPasswordEmail({
        body: this.forgotPasswordForm.value,
      })
      .subscribe({
        next: () => {
          this.toastrService.success(
            this.translate.instant("AUTH.PASSWORD.FORGOT_SUCCESS_MESSAGE"),
            this.translate.instant("AUTH.PASSWORD.FORGOT_SUCCESS_TITLE")
          );
          this.router.navigate(["/login"]);
        },
        error: (err) => console.error(err),
      });
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.forgotPasswordForm = this._formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
